import {ProjectsSortMode} from '../../dashboard/enums/projects-sort-mode';
import {ProjectsLayoutMode} from '../../dashboard/enums/projects-layout-mode';
import {ThemeId} from '../../common/enums/theme-id';
import {CrosshairMode} from "../enums/crosshair-mode.enum";

export class LocalSettings {

  minimalUi = false;

  crosshairMode: CrosshairMode = CrosshairMode.polygon;
  adminMode = true;
  pinSound = true;
  showCrosshairCoordinates = false;
  alwaysShowCrosshair = false;
  firstCrosshairShow = false;
  // The "new" dot on the map's Layers button, until the menu is first opened.
  layersMenuSeen = false;
  showMyLocation = false;
  clusterMarkers = true;
  previewCrosshairOp = true;
  geodesicEnabled = true;
  showHelpBox = true;
  snapToPoint = true;
  showPolygons = true;
  showLockPolygonMarker = true;

  showHDMaps = true;

  // showLabels = true;
  showPolygonLabels = true;
  showIntermediateDistancesLabels = true;
  showDescriptionLabels = true;
  showSpotNameLabel = true;
  showPolygonNameLabel = true;
  showPolygonAreaLabel = true;
  showPolygonPerimeterLabel = false;

  defaultSpotIconColor = '#888888';
  defaultSpotIconId = 0;

  showHoleLabels = true;
  showSpots = true;
  showPins = true;
  /**
   * Draw detections as a dot per result instead of the full mask.
   *
   * A prompt that matches thirty things covers the map in translucent shapes,
   * and the imagery underneath is the only way to judge whether any of them is
   * right. Dots keep it readable; hovering one brings its mask back.
   */
  detectionAsDots = true;
  showComments = true;
  showMeasurementsBox = true;
  addCommentsEnabled = false;
  showParcels = false;
  showBuildingsOverlays = false;
  showParcelsAreaPopup = true;
  showParcelsAnnouncementPopup = true;
  showPolygonTitleLabelBackground = true;
  showPointDescriptionLabelBackground = true;
  showSpotNameLabelBackground = true;
  projectsSortMode = ProjectsSortMode.LAST_OPENED;
  projectsLayoutMode = ProjectsLayoutMode.GRID;
  lastAppVersion = '';
  createGeoGroupColor = '#FF0000';

  theme = ThemeId.LIGHT;
  showGeoGroups = false;
  lastProjectsMapBounds = '';

  showProjectsTourFeatures = true;
  showProjectsMapViewTourFeatures = true;

  accessToken = '';

  showTrafficLayer = false;
  show3DMaps = false;

  // ── 3D view ──────────────────────────────────────────────────────
  /** Which map the canvas is showing. See ViewMode. */
  viewMode = '2d';
  /**
   * Where shapes sit in 3D unless a shape says otherwise. See AltitudeMode3d.
   *
   * Draped over the buildings by default, because that is the case this was
   * built for — a roof outline belongs on the roof, not on the earth beneath
   * it. Site work wants the ground; a proper flat roof plane wants a fixed
   * height, which each shape can set for itself.
   */
  default3dAltitudeMode = 'mesh';
  /** Height in metres used by shapes set to a fixed altitude. */
  default3dAltitude = 0;
  /** Raise polygons into solid volumes — useful for showing height or spoil. */
  extrudePolygons = false;
  /** Camera pitch used when entering 3D from the flat map. */
  defaultTilt = 55;
}
